export default "__VITE_ASSET__BA9H8dI___"